import React from "react";
import { formatDateTime } from "../../../dataGrid/gridUtilities";
import { getFormattedDeliveryWindowList } from "../../../dataGrid/gridUtilities";

const getServiceWindowContent = (params) => {
  return getFormattedDeliveryWindowList(params).map((deliverySlot, index) => (
    <React.Fragment key={index}>
      <span>{deliverySlot}</span>
      <br />
    </React.Fragment>
  ));
};

const getPopupContent = ({
  showDateRangeInShipmentSelection,
  params,
  infoData,
}) => {
  const serviceWindow = getServiceWindowContent(params);
  if (showDateRangeInShipmentSelection) {
    //for client FFE
    return [
      {
        labels: ["Service Window"],
        labelClass: "firstTableCell",
        values: [serviceWindow],
        valueClass: "firstTableCell",
      },
      { labels: ["Est Arrival"], values: [infoData.eta] },
      { labels: ["Stop Time"], values: [infoData.stopTime] },
      { labels: ["Bills"], values: [infoData.bills] },
      {
        labels: ["Weight", "Temp Type"],
        values: [`${infoData.totalWeight} lbs`, infoData.tempType],
      },
      {
        labels: ["Cooler Plt", "Freezer Plt"],
        values: [infoData.coolerPlts, infoData.freezerPlts],
      },
      { labels: ["Stop Type"], values: [infoData.stopType] },
      ...(infoData.specialInstruction
        ? [
            {
              labels: ["Special Instructions"],
              labelClass: "nameCellPadding",
              values: [infoData.specialInstruction],
              showTooltip: true,
            },
          ]
        : []),
    ];
  }
  //default (SAIA)
  return [
    {
      labels: ["Service Window"],
      labelClass: "firstTableCell",
      values: [serviceWindow],
      valueClass: "firstTableCell",
    },
    { labels: ["ETA"], values: [infoData.eta] },
    {
      labels: ["Weight", "PSE"],
      values: [`${infoData.totalWeight} lbs`, infoData.pse],
    },
    { labels: ["Bills"], values: [infoData.bills] },
    ...(infoData.stopIbeta
      ? [
          {
            labels: ["Max IB ETA"],
            values: [formatDateTime({ value: infoData.stopIbeta })],
          },
        ]
      : []),
    ...(infoData.specialInstruction
      ? [
          {
            labels: ["Special Instructions"],
            labelClass: "nameCellPadding",
            values: [infoData.specialInstruction],
            showTooltip: true,
          },
        ]
      : []),
  ];
};

export { getPopupContent };
